import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/companyPrimaryAreaOfConstruction'
export const namespace = 'companyPrimaryAreaOfConstruction'
export const clientRoute = '/company/company-primary-area-of-construction'
export const dependencies = ['company', 'primaryAreaOfConstruction']
export const params = {
  include: 'company,primaryAreaOfConstruction'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'primaryAreaOfConstruction'
const subtitleColumn = 'Company'
const infoColumns = []
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
